/**
 * KAN-834: сессия приложения менеджера закончилась (refresh не вышел).
 * KAN-846: войти можно по логину и паролю (кнопка ведёт на /m/login) или по
 * новой ссылке от руководителя.
 */
import { Link } from 'react-router-dom';
import { MobileScreen } from '@/components/mobile/MobileScreen';
import { MOBILE_LOGIN_PATH } from '@/lib/mobileApp';

export const LOGIN_EXPIRED_TEXT = 'Попросите новую ссылку для входа';
export const PASSWORD_LOGIN_BUTTON = 'Войти по логину и паролю';

export function MobileLoginExpiredPage(): JSX.Element {
  return (
    <MobileScreen>
      <div className="space-y-4" data-testid="app-login-expired">
        <div className="space-y-2">
          <p className="text-lg font-semibold text-gray-900">Вход закончился</p>
          <p className="text-gray-700">{LOGIN_EXPIRED_TEXT} у руководителя или войдите по логину и паролю.</p>
        </div>
        <Link
          to={MOBILE_LOGIN_PATH}
          className="flex h-12 w-full items-center justify-center rounded-xl bg-blue-600 text-base font-medium text-white active:bg-blue-700"
        >
          {PASSWORD_LOGIN_BUTTON}
        </Link>
      </div>
    </MobileScreen>
  );
}
